import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSearch(props: SvgIconProps) {
  return (
    <SVGIcon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="search-icon"
      {...props}
    >
      <g clipPath="url(#a)" stroke="currentColor" strokeWidth="1.6">
        <rect x="2.131" y="7.5" width="8.4" height="8.4" rx="4.2" transform="rotate(-45 2.131 7.5)" />
        <path d="m10.9 10.328 4.242 4.243" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
